import React from 'react';
import '../svg.css';


const Furniture = props => {
    const { fill } = props;
    return (
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"
            height="36px"
            width="36px"
            className='svg'
        >
            <g id="messages_furniture" data-name="messages/furniture"><g id="Logo"><rect id="frame" className="furniture-1" width="36" height="36" rx="10" /></g><g id="Group"><rect id="bound" className="furniture-2" x="6" y="6" width="24" height="24" /><path id="Path-61" className="furniture-3" d="M10,28H8c0-2.76,2.24-4,5-4H23c2.76,0,5,1.24,5,4H26c0-1.66-1.34-2-3-2H13C11.34,26,10,26.34,10,28Z" /><rect id="Rectangle-137" className="furniture-4" x="7" y="20" width="22" height="6" rx="1" /><path id="Combined-Shape" className="furniture-5" d="M25,12a2,2,0,0,1,2,2v4a1,1,0,0,1-1,1H25V18a1,1,0,0,0-1-1H20a1,1,0,0,0-1,1h0v1H17V18a1,1,0,0,0-1-1H12a1,1,0,0,0-1,1h0v1H10a1,1,0,0,1-1-1V14a2,2,0,0,1,2-2Z" /></g></g>
        </svg>
    );
};

export default Furniture;
